import React from 'react'
import FacturasProveedores from '../components/FacturasProveedores'

const facturasProveedores = () => {
  return (
    <FacturasProveedores />
  )
}

export default facturasProveedores